import clsx from 'clsx'
import styles from '@/components/ZbNavigation/Toolbar/toolbar.module.css'
import ZbLink from '@/components/ZbLink'
import SVGChevron from '@/components/SVGIcons/SVGChevron'
import { Fragment } from 'react'
import { BreadcrumbJSONSchema } from '@/components/Breadcrumb/BreadcrumbJSONSchema'

export type BreadcrumbItem = {
  title: string
  url: string
}

type BreadcrumbProps = { breadcrumbs?: BreadcrumbItem[] }

export function Breadcrumb({ breadcrumbs }: BreadcrumbProps) {
  return (
    <Fragment>
      <BreadcrumbJSONSchema breadcrumbs={breadcrumbs} />
      <div className={clsx(styles.ToolbarBreadcrumbsContainer)}>
        {breadcrumbs?.map((breadcrumb, index) => (
          <div key={breadcrumb?.title}>
            <ZbLink
              type="unstyled"
              to={breadcrumb?.url}
              className={clsx(
                styles.ToolbarBreadcrumb,
                index !== 0 ? styles.hideOnDesktop : ''
              )}
            >
              <span>{breadcrumb?.title}</span>
            </ZbLink>
            {index < breadcrumbs.length - 1 && (
              <SVGChevron size={{ width: '10px', height: '10px' }} />
            )}
          </div>
        ))}
      </div>
    </Fragment>
  )
}
